import { render, staticRenderFns } from "./panel_ymcq.vue?vue&type=template&id=1d37e57e&scoped=true&"
import script from "./panel_ymcq.vue?vue&type=script&lang=js&"
export * from "./panel_ymcq.vue?vue&type=script&lang=js&"
import style0 from "./panel_ymcq.vue?vue&type=style&index=0&id=1d37e57e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d37e57e",
  null
  
)

export default component.exports